export default (props) => (
  <svg
    width="182"
    height="45"
    viewBox="0 0 182 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    {...props}
  >
    <g clipPath="url(#clip0_3808_16228)">
      <path
        d="M25.6539 27.5979C23.2314 31.2628 19.5666 34.7413 18.8833 35.4246L18.759 35.5488C9.87645 34.8034 2.42253 28.4055 0.186348 20.0819C0.062116 21.0758 0 22.1317 0 23.1877C0 26.9768 0.745393 30.3932 2.29829 33.3126C3.85119 36.2942 6.02526 38.5925 8.88259 40.2075C11.7399 41.8846 15.0942 42.6921 18.9454 42.6921C22.2997 42.6921 25.2191 42.071 27.8901 40.8287C30.499 39.5863 32.673 37.8471 34.2881 35.5488C35.9652 33.2505 37.0212 30.5795 37.5802 27.5979H25.6539Z"
        fill="#1D1F21"
      />
      <path
        d="M18.7595 34.8655C17.6414 33.8096 9.69052 26.1693 9.69052 21.5106V21.0137C9.69052 12.8143 15.5294 5.85734 22.797 3.24846C22.238 3.18635 21.1199 3.12423 20.5608 3.06212C20.0639 3 19.5049 3 18.9458 3C15.0946 3.06212 11.7404 3.86962 8.88301 5.48464C6.02568 7.16177 3.85161 9.46007 2.29871 12.3795C1.18062 14.5536 0.497348 17.5352 0.186768 20.0819C2.42295 28.4055 9.87687 34.1823 18.7595 34.8655Z"
        fill="#1D1F21"
      />
      <path
        d="M10.3728 21.0757V21.1378C10.4349 20.0197 10.6834 18.9016 11.1182 17.9699C12.4847 14.7399 15.7148 12.5037 19.4417 12.5037C23.1687 12.5037 26.523 14.8641 27.8274 18.2184H38.2629C37.7039 15.1747 36.6479 12.5037 34.9708 10.2675C33.2936 7.9071 31.1196 6.16785 28.5107 4.92553C26.7714 4.11802 24.8458 3.55898 22.796 3.2484C15.5284 5.91939 10.3728 12.8764 10.3728 21.0757Z"
        fill="#1D1F21"
      />
      <path
        d="M63.1721 13.7461C67.1475 13.7461 70.4397 15.858 71.6199 19.585H67.4581C66.5885 17.8457 65.0356 16.9761 63.11 16.9761C59.942 16.9761 57.7059 19.2744 57.7059 22.9392C57.7059 26.6041 59.942 28.9024 63.11 28.9024C65.0356 28.9024 66.5885 28.0328 67.4581 26.2935H71.6199C70.3775 30.0205 67.1475 32.1324 63.1721 32.1324C58.0164 32.1324 54.041 28.3433 54.041 22.9392C54.041 17.5351 57.9543 13.7461 63.1721 13.7461Z"
        fill="#1D1F21"
      />
      <path
        d="M80.4402 17.473C82.7384 17.473 84.2914 18.529 85.161 19.7713V17.7215H88.8258V32.0082H85.161V29.8962C84.2914 31.1386 82.6763 32.1945 80.4402 32.1945C76.8374 32.1945 73.918 29.213 73.918 24.7406C73.918 20.3304 76.7753 17.473 80.4402 17.473ZM81.3719 20.6409C79.4463 20.6409 77.5828 22.0696 77.5828 24.8027C77.5828 27.5358 79.3842 29.0887 81.3719 29.0887C83.3596 29.0887 85.161 27.5979 85.161 24.8648C85.161 22.1317 83.3596 20.6409 81.3719 20.6409Z"
        fill="#1D1F21"
      />
      <path
        d="M96.0319 31.946H92.4292V17.6593H96.0319V19.8955C96.9637 18.4047 98.4545 17.473 100.442 17.473V21.2621H99.5104C97.3985 21.2621 96.094 22.0696 96.094 24.8648V31.946H96.0319Z"
        fill="#1D1F21"
      />
      <path
        d="M109.2 32.1944C105.039 32.1944 102.057 29.3371 102.057 24.8026C102.057 20.2681 104.977 17.4108 109.2 17.4108C113.424 17.4108 116.22 20.206 116.22 24.492C116.22 24.9268 116.22 25.4238 116.095 25.8586H105.66C105.846 27.9705 107.275 29.1507 109.076 29.1507C110.629 29.1507 111.499 28.4053 111.934 27.4115H115.847C115.101 30.1446 112.741 32.1944 109.2 32.1944ZM105.722 23.4982H112.493C112.431 21.6347 110.94 20.4545 109.076 20.4545C107.399 20.3924 106.033 21.5105 105.722 23.4982Z"
        fill="#1D1F21"
      />
      <path
        d="M125.226 32.1324C121.499 32.1324 118.58 30.1447 118.518 26.7904H122.369C122.493 28.2191 123.425 29.2129 125.102 29.2129C126.779 29.2129 127.835 28.2812 127.835 27.0389C127.835 23.1255 118.58 25.4859 118.58 18.9638C118.58 15.7337 121.189 13.746 124.916 13.746C128.643 13.746 131.127 15.6095 131.376 18.9016H127.4C127.338 17.7214 126.344 16.7897 124.792 16.7897C123.363 16.7276 122.307 17.4109 122.307 18.9016C122.307 22.5044 131.562 20.5167 131.562 26.8525C131.624 29.5856 129.326 32.1324 125.226 32.1324Z"
        fill="#1D1F21"
      />
      <path
        d="M141.065 32.1944C136.903 32.1944 133.922 29.3371 133.922 24.8026C133.922 20.2681 136.841 17.4108 141.065 17.4108C145.289 17.4108 148.084 20.206 148.084 24.492C148.084 24.9268 148.084 25.4238 147.96 25.8586H137.525C137.711 27.9705 139.14 29.1507 140.941 29.1507C142.494 29.1507 143.364 28.4053 143.798 27.4115H147.712C146.966 30.1446 144.606 32.1944 141.065 32.1944ZM137.587 23.4982H144.357C144.295 21.6347 142.804 20.4545 140.941 20.4545C139.264 20.3924 137.897 21.5105 137.587 23.4982Z"
        fill="#1D1F21"
      />
      <path
        d="M160.881 24.0573C160.881 21.759 159.638 20.5167 157.713 20.5167C155.787 20.5167 154.483 21.759 154.483 24.0573V31.946H150.88V17.6593H154.483V19.4607C155.415 18.2184 156.968 17.473 158.769 17.473C162.123 17.473 164.484 19.647 164.484 23.5603V31.946H160.881V24.0573Z"
        fill="#1D1F21"
      />
      <path
        d="M173.676 17.473C175.54 17.473 177.341 18.3427 178.335 19.7092V12.8764H182V31.9461H178.335V29.8341C177.465 31.1386 175.913 32.1945 173.614 32.1945C169.949 32.1945 167.092 29.213 167.092 24.7406C167.154 20.3304 170.011 17.473 173.676 17.473ZM174.608 20.641C172.682 20.641 170.819 22.0696 170.819 24.8027C170.819 27.5358 172.62 29.0887 174.608 29.0887C176.596 29.0887 178.397 27.598 178.397 24.8648C178.397 22.1317 176.596 20.641 174.608 20.641Z"
        fill="#1D1F21"
      />
    </g>
    <defs>
      <clipPath id="clip0_3808_16228">
        <rect
          width="182"
          height="39.6922"
          fill="white"
          transform="translate(0 3)"
        />
      </clipPath>
    </defs>
  </svg>
)
